/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.automation.reporting.rpc.ConversionRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getConversionReportingEnablementSettingRpc = {
  serviceName: 'com.hubspot.automation.reporting.rpc.ConversionRpc',
  rpcName: 'getConversionReportingEnablementSetting',
  auth: 'app',
  fingerprint: 'YyDuOVotXuEM4_R5IKOl_pwP6LXzGzX8'
};
export const enableConversionReportingRpc = {
  serviceName: 'com.hubspot.automation.reporting.rpc.ConversionRpc',
  rpcName: 'enableConversionReporting',
  auth: 'app',
  fingerprint: '0nt7K0efi9ik3MybRrNNsJwP6LXzGzX8'
};